var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgot_footer"},[_c('div',{staticClass:"copyright_info white"},[_c('span',[_vm._v("COPYRIGHT   © 2010-2021  SAMEX Systems\n      Limited.  ")]),_c('span',[_vm._v(_vm._s(_vm.pageText.copyRight))])])])}
var staticRenderFns = []

export { render, staticRenderFns }